import { useOutletContext } from 'react-router';

import OnboardingStepOne from '@/components/onboarding/OnboardingStepOne/OnboardingStepOne';

export const OnboardingStepOneFunctionalWrapper = () => {
  const [saveStepData, stepData] = useOutletContext();

  return <OnboardingStepOne saveStepData={saveStepData} stepData={stepData} />;
};
